import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { Chart, ChartOptions, ChartType } from "chart.js";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { BundleService } from "src/app/Services/bundleservice.service";
import { DatePipe } from "@angular/common";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { OrgContextService } from "src/app/Services/org-context.service";
import { FrontlineFeatureFlags } from "src/app/shared/constants/frontline-glossary";
import { Subscription } from "rxjs";

@Component({
  selector: "app-content-analytics",
  templateUrl: "./content-analytics.component.html",
  styleUrls: ["./content-analytics.component.scss"],
})
export class ContentAnalyticsComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Organization content is never sold, so revenue and donation charts are hidden in org mode. */
  showPaidContent = true;
  private orgSub?: Subscription;

  get showConsultationCharts(): boolean {
    return this.showPaidContent && FrontlineFeatureFlags.showConsultations;
  }

  userData: any;
  userEmail: string;
  noResultReturned: boolean;
  linksClicked: any = [];
  bundleLinksClicked: any = [];
  pageViews: any = [];
  flowViews: any = [];
  bundleViews: any = [];
  linkClickViews: any = [];
  dashboardModel: any;
  flowData: any;
  totalLinkClicks: number = 0;

  @ViewChild("pieChartCanvas", { static: true })
  pieChartCanvas: ElementRef<HTMLCanvasElement>;
  public pieChartOptions: any = {
    responsive: true,
  };
  @ViewChild("lineChartCanvas", { static: true })
  lineChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundlelineChartCanvas", { static: true })
  bundlelineChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("consultChartCanvas", { static: true })
  consultChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("consultPurchaseCountChartCanvas", { static: true })
  consultPurchaseCountChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("donationViewsChartCanvas", { static: true })
  donationViewsChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("flowViewslineChartCanvas", { static: true })
  flowViewslineChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundleViewslineChartCanvas", { static: true })
  bundleViewslineChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("flowLinkClicklineChartCanvas", { static: true })
  flowLinkClicklineChartCanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild("bundleLinkClicklineChartCanvas", { static: true })
  bundleLinkClicklineChartCanvas: ElementRef<HTMLCanvasElement>;
  public lineChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  public lineChartLabels: string[] = [];
  public bundlelineChartLabels: string[] = [];
  public flowviewslineChartLabels: string[] = [];
  public bundleViewslineChartLabels: string[] = [];
  public donationViewslineChartLabels: string[] = [];
  public consultViewslineChartLabels: string[] = [];
  public consultPurchaseCountlineChartLabels: string[] = [];
  public flowLinkClicklineChartLabels: string[] = [];
  public bundleLinkClicklineChartLabels: string[] = [];
  public lineChartType: ChartType = "line";
  public lineChartLegend = true;
  public lineChartData: number[] = [];
  public bundlelineChartData: number[] = [];
  public lineFlowViewChartData: number[] = [];
  public lineBundleViewlineChartData: number[] = [];
  public donationViewslineChartData: number[] = [];
  public lineConsultViewlineChartData: number[] = [];
  public lineConsultPurchaseCountlineChartData: number[] = [];
  public flowlinkClicklineChartData: number[] = [];
  public bundlelinkClicklineChartData: number[] = [];
  returningUsersCount: number = 0;
  newUsersCount: number = 0;
  viewMode: 'table' | 'card' = 'table';
  bundleViewMode: 'table' | 'card' = 'table';

  public pieChartLabels: string[] = ["Label 1", "Label 2", "Label 3"];
  public pieChartData: number[] = [300, 500, 200];
  public pieChartType: string = "pie";
  public pieChartLegend: boolean = true;
  linkClicks: any[] = [];
  totalFlowLinkClicks: number;
  pageViewsBundles: any = [];
  flowLinksClick: any;
  bundleLinksClick: any;
  consultViews: any;
  consultPurchaseCount: any;
  donationViews: any;
  /**
   *
   */
  constructor(
    private flowservice: FlowServiceService,
    private bundleservice: BundleService,
    private eventEmitterService: EventEmitterService,
    private cdr: ChangeDetectorRef,
    private orgContext: OrgContextService
  ) {}

  ngOnDestroy(): void {
    this.orgSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.eventEmitterService.setDashboardMenuStyleProperty("analytics");
  }

  onTabChange(event: MatTabChangeEvent) {
    // When switching back to Overview tab (index 0), re-initialize all charts
    if (event.index === 0) {
      // Use setTimeout to ensure the canvas elements are rendered in the DOM
      this.cdr.detectChanges();
      setTimeout(() => {
        this.reinitializeAllCharts();
      }, 150);
    }
  }

  reinitializeAllCharts() {
    // Ensure data is extracted before re-initializing charts
    if (this.pageViews && this.pageViews.length > 0) {
      this.extractDateRange();
      if (this.lineChartCanvas?.nativeElement) {
        this.destroyChart(this.lineChartCanvas);
        this.initLineChart();
      }
    }
    
    if (this.pageViewsBundles && this.pageViewsBundles.length > 0) {
      this.extractBundleDateRange();
      if (this.bundlelineChartCanvas?.nativeElement) {
        this.destroyChart(this.bundlelineChartCanvas);
        this.initBundleLineChart();
      }
    }
    
    if (this.flowViews && this.flowViews.length > 0) {
      this.extractFlowViewDateRange();
      if (this.flowViewslineChartCanvas?.nativeElement) {
        this.destroyChart(this.flowViewslineChartCanvas);
        this.initFlowViewLineChart();
      }
    }
    
    if (this.bundleViews && this.bundleViews.length > 0) {
      this.extractBundleViewDateRange();
      if (this.bundleViewslineChartCanvas?.nativeElement) {
        this.destroyChart(this.bundleViewslineChartCanvas);
        this.initBundleViewLineChart();
      }
    }
    
    if (this.flowLinksClick && this.flowLinksClick.length > 0) {
      this.extractFlowLinkClickDateRange();
      if (this.flowLinkClicklineChartCanvas?.nativeElement) {
        this.destroyChart(this.flowLinkClicklineChartCanvas);
        this.initFlowLinkClickLineChart();
      }
    }
    
    if (this.bundleLinksClick && this.bundleLinksClick.length > 0) {
      this.extractBundleLinkClickDateRange();
      if (this.bundleLinkClicklineChartCanvas?.nativeElement) {
        this.destroyChart(this.bundleLinkClicklineChartCanvas);
        this.initBundleLinkClickLineChart();
      }
    }
    
    if (this.consultViews && this.consultViews.length > 0) {
      this.extractConsultViewDateRange();
      if (this.consultChartCanvas?.nativeElement) {
        this.destroyChart(this.consultChartCanvas);
        this.initConsultViewLineChart();
      }
    }
    
    if (this.consultPurchaseCount && this.consultPurchaseCount.length > 0) {
      this.extractConsultPurchaseCountDateRange();
      if (this.consultPurchaseCountChartCanvas?.nativeElement) {
        this.destroyChart(this.consultPurchaseCountChartCanvas);
        this.initConsultPurchaseCountLineChart();
      }
    }
    
    if (this.donationViews && this.donationViews.length > 0) {
      this.extractDonationViewsDateRange();
      if (this.donationViewsChartCanvas?.nativeElement) {
        this.destroyChart(this.donationViewsChartCanvas);
        this.initDonationViewsLineChart();
      }
    }
  }

  ngOnInit(): void {
    console.log("Welcome");

    this.flowData = JSON.parse(localStorage.getItem("analyticsflow"));
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.userEmail = "";

    if (this.userData != null) {
      this.userEmail = this.userData.emailAddress;
    }
    
    // On mobile, default to card view (better UX for narrow screens)
    if (window && window.innerWidth <= 768) {
      this.viewMode = 'card';
      this.bundleViewMode = 'card';
    }
    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    });
    // Emits immediately, which runs the first load for the selected account.
    this.orgSub = this.orgContext.watch().subscribe(() => {
      const scope = this.orgContext.accountScopeQuery();
      const key = `${scope.accountScope}:${scope.organizationId || ""}`;
      if (key === this.scopeKey) return;
      this.scopeKey = key;
      this.showPaidContent = !this.orgContext.isOrganizationMode();
      this.getUserAllLinksAnalytics(flowQueryModel);
      this.getUserAllBundleLinksAnalytics(flowQueryModel);
      this.onTimePeriodChange();
    });
  }

  private scopeKey = "";

  onTimePeriodChange() {
    this.resetChartData();
    this.getFlowContentCount();
    this.getBundleContentCount();
    this.getFlowViewsContentCount();
    this.getBundleViewsContentCount();
    this.getFlowLinksContentCount();
    this.getBundleLinksContentCount();
    if (this.showConsultationCharts) this.getPurchaseByConsult();
    if (this.showPaidContent) this.getDonationList();
  }
  resetChartData() {
    this.lineChartData = [];
    this.bundlelineChartData = [];
    this.lineFlowViewChartData = [];
    this.lineBundleViewlineChartData = [];
    this.donationViewslineChartData = [];
    this.lineConsultViewlineChartData = [];
    this.lineConsultPurchaseCountlineChartData = [];
    this.flowlinkClicklineChartData = [];
    this.bundlelinkClicklineChartData = [];
  }

  calculateTotalLinkClicks() {
    this.totalLinkClicks = 0;
    this.totalFlowLinkClicks = 0;

    for (let content of this.linksClicked) {
      this.totalFlowLinkClicks += content.totalCount;
    }
    for (let content of this.bundleLinksClicked) {
      this.totalLinkClicks += content.totalCount;
    }
    console.log(this.totalLinkClicks);
    console.log(this.totalFlowLinkClicks);
  }
  getUserDashboard(flowQueryModel) {
    var flowModel = new FlowQueryModel({
      FlowType: this.flowData.flowType,
      FlowId: this.flowData.id,
    });
    this.noResultReturned = true;
    this.flowservice.getLinkClickDetails(flowModel).subscribe((data) => {
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.linksClicked = data;
    });
  }

  getUserAllLinksAnalytics(flowQueryModel) {
    var flowModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    });

    this.noResultReturned = true;
    this.flowservice.getAllLinkClickDetails(flowModel).subscribe((data) => {
      console.log(data);
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.linksClicked = data;
      this.calculateTotalLinkClicks();
    });
  }
  getUserAllBundleLinksAnalytics(flowQueryModel) {
    var flowModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    });

    this.noResultReturned = true;
    this.bundleservice.getAllBundleLinkClicks(flowModel).subscribe((data) => {
      console.log(data);
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.bundleLinksClicked = data;
      this.calculateTotalLinkClicks();
    });
  }
  selectedTimePeriod: "daily" | "weekly" | "monthly" | "year" = "year"; // Default to weekly

  getFlowContentCount() {
    this.noResultReturned = true;
    var getPageViewDetails = {
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    };
    this.flowservice.getContentDetails(getPageViewDetails).subscribe((data) => {
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.pageViews = data;
      // this.setNewandReturningUsers();
      this.flowChartData();
    });
  }

  getBundleContentCount() {
    this.noResultReturned = true;
    var getPageViewDetails = {
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    };
    this.flowservice
      .getBundleContentDetails(getPageViewDetails)
      .subscribe((data: any) => {
        this.noResultReturned = false;
        // this.dashboardModel = data.DashboardModel;
        this.pageViewsBundles = data;
        console.log(this.pageViewsBundles);
        // this.setNewandReturningUsers();
        this.bundleChartData();
      });
  }
  getFlowViewsContentCount() {
    this.noResultReturned = true;
    var getPageViewDetails = {
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    };
    this.flowservice.getContentDetails(getPageViewDetails).subscribe((data) => {
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.flowViews = data;
      // this.setNewandReturningUsers();
      this.flowViewsChartData();
    });
  }
  getBundleViewsContentCount() {
    this.noResultReturned = true;
    var getPageViewDetails = {
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    };
    this.flowservice
      .getBundleContentDetails(getPageViewDetails)
      .subscribe((data: any) => {
        this.noResultReturned = false;
        // this.dashboardModel = data.DashboardModel;
        this.bundleViews = data;
        console.log(this.bundleViews);
        // this.setNewandReturningUsers();
        this.bundleViewsChartData();
      });
  }

  getPurchaseByConsult() {
    this.noResultReturned = true;
    var getPageViewDetails = {
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    };
    this.flowservice
      .getPurchaseByConsult(getPageViewDetails)
      .subscribe((data: any) => {
        this.noResultReturned = false;
        // this.dashboardModel = data.DashboardModel;
        this.consultViews = data;
        this.consultPurchaseCount = data;
        console.log(this.consultViews);
        // this.setNewandReturningUsers();
        this.consultViewsChartData();
        this.consultPurchaseCountChartData();
      });
  }

  getDonationList() {
    this.noResultReturned = true;
    var getPageViewDetails = new FlowQueryModel({
      FlowId: this.userData.rowKey,
    });
    this.flowservice
      .getGiftedFundsByCustomerRowKey(getPageViewDetails)
      .subscribe((data: any) => {
        this.noResultReturned = false;
        // this.dashboardModel = data.DashboardModel;
        this.donationViews = data;
        console.log(this.donationViews);
        // this.setNewandReturningUsers();
        this.donationViewsChartData();
      });
  }
  getFlowLinksContentCount() {
    var flowModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    });

    this.noResultReturned = true;
    this.flowservice.getAllLinkClickDetails(flowModel).subscribe((data) => {
      console.log(data);
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.flowLinksClick = data;
      this.calculateTotalLinkClicks();
      this.flowLinkClickChartData();
    });
  }
  getBundleLinksContentCount() {
    var flowModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      ...this.orgContext.accountScopeQuery(),
    });

    this.noResultReturned = true;
    this.bundleservice.getAllBundleLinkClicks(flowModel).subscribe((data) => {
      console.log(data);
      this.noResultReturned = false;
      // this.dashboardModel = data.DashboardModel;
      this.bundleLinksClick = data;
      this.calculateTotalLinkClicks();
      this.bundleLinkClickChartData();
    });
  }
  flowChartData() {
    this.extractDateRange();
    // this.updateChartData();
    this.destroyChart(this.lineChartCanvas);
    this.initLineChart();
  }

  flowViewsChartData() {
    this.extractFlowViewDateRange();
    // this.updateFlowViewChartData();
    this.destroyChart(this.flowViewslineChartCanvas);
    this.initFlowViewLineChart();
  }
  flowLinkClickChartData() {
    this.extractFlowLinkClickDateRange();
    // this.updateFlowLinkClickChartData();
    this.destroyChart(this.flowLinkClicklineChartCanvas);
    this.initFlowLinkClickLineChart();
  }
  bundleChartData() {
    this.extractBundleDateRange();
    // this.updateBundleChartData();
    this.destroyChart(this.bundlelineChartCanvas);
    this.initBundleLineChart();
  }
  bundleViewsChartData() {
    this.extractBundleViewDateRange();
    // this.updateBundleViewChartData();
    this.destroyChart(this.bundleViewslineChartCanvas);
    this.initBundleViewLineChart();
  }
  consultPurchaseCountChartData() {
    this.extractConsultViewDateRange();
    // this.updateConsultViewChartData();
    this.destroyChart(this.consultChartCanvas);
    this.initConsultViewLineChart();
  }
  consultViewsChartData() {
    this.extractConsultPurchaseCountDateRange();
    // this.updateConsultPurchaseCountChartData();
    this.destroyChart(this.consultPurchaseCountChartCanvas);
    this.initConsultPurchaseCountLineChart();
  }
  donationViewsChartData() {
    this.extractDonationViewsDateRange();
    // this.updateDonationViewsChartData();
    this.destroyChart(this.donationViewsChartCanvas);
    this.initDonationViewsLineChart();
  }
  bundleLinkClickChartData() {
    this.extractBundleLinkClickDateRange();
    // this.updateBundleLinkClickChartData();
    this.destroyChart(this.bundleLinkClicklineChartCanvas);
    this.initBundleLinkClickLineChart();
  }
  destroyChart(canvas: ElementRef<HTMLCanvasElement>) {
    if (canvas?.nativeElement) {
      const ctx = canvas.nativeElement.getContext("2d");
      if (ctx) {
        Chart.getChart(ctx)?.destroy(); // Destroy existing chart instance if it exists
      }
    }
  }

  initLineChart() {
    console.log(this.lineChartLabels);
    const lineChartCtx = this.lineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.lineChartLabels,
        datasets: [
          {
            data: this.lineChartData,
            label: "Flows Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }

  private updateChartData() {
    let totalViews = 0;
    console.log(this.pageViews);
    this.pageViews.forEach((element) => {
      totalViews += element.numberOfViews;
      console.log("Updated totalViews:", totalViews);
      this.lineChartData.push(totalViews);
      console.log("Updated lineChartData:", this.lineChartData);
    });
  }
  extractDateRange() {
    if (!this.pageViews || this.pageViews.length === 0) return;
    this.lineChartLabels = [];
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.pageViews.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.numberOfViews);
    });

    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    }); // Set data
    this.lineChartLabels = sortedEntries.map(([label]) => label);
    this.lineChartData = sortedEntries.map(([_, value]) => value);
  }
  extractFlowViewDateRange() {
    if (!this.flowViews || this.flowViews.length === 0) return;
    let totalFlowViews = 0;
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.flowViews.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      const flowViewsCount = parseInt(item.totalFlowViews, 10);
      if (!isNaN(flowViewsCount)) {
        totalFlowViews += flowViewsCount;
        groupedData.set(label, views + totalFlowViews);
      }
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });
    // Set data
    this.flowviewslineChartLabels = sortedEntries.map(([label]) => label);
    this.lineFlowViewChartData = sortedEntries.map(([_, value]) => value);
  }

  extractBundleDateRange() {
    if (!this.pageViewsBundles || this.pageViewsBundles.length === 0) return;

    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.pageViewsBundles.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.numberOfViews);
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data
    // Sort labels if needed (e.g., descending by time)
    this.bundlelineChartLabels = sortedEntries.map(([label]) => label);
    this.bundlelineChartData = sortedEntries.map(([_, value]) => value);
  }

  initBundleLineChart() {
    console.log(this.bundlelineChartData);
    const lineChartCtx =
      this.bundlelineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.bundlelineChartLabels,
        datasets: [
          {
            data: this.bundlelineChartData,
            label: "Bundles Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  initConsultViewLineChart() {
    console.log(this.lineConsultViewlineChartData);
    const lineChartCtx = this.consultChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.consultViewslineChartLabels,
        datasets: [
          {
            data: this.lineConsultViewlineChartData,
            label: "Consultation Revenue Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  initConsultPurchaseCountLineChart() {
    console.log(this.lineConsultPurchaseCountlineChartData);
    const lineChartCtx =
      this.consultPurchaseCountChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.consultPurchaseCountlineChartLabels,
        datasets: [
          {
            data: this.lineConsultPurchaseCountlineChartData,
            label: "Consultation Received Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  initDonationViewsLineChart() {
    console.log(this.donationViewslineChartData);
    const lineChartCtx =
      this.donationViewsChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.donationViewslineChartLabels,
        datasets: [
          {
            data: this.donationViewslineChartData,
            label: "£ Donation Received Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  private updateBundleChartData() {
    let totalBundleViews = 0;
    console.log(this.pageViewsBundles);
    this.pageViewsBundles.forEach((element: any) => {
      totalBundleViews += element.numberOfViews;
      console.log("Updated totalViews:", totalBundleViews);
      this.bundlelineChartData.push(totalBundleViews);
      console.log("Updated lineChartData:", this.bundlelineChartData);
    });
  }
  private updateConsultViewChartData() {
    this.lineConsultViewlineChartData = [];
    let totalConsultViews = 0;
    this.consultViews.forEach((element: any) => {
      totalConsultViews += element.purchasedAmount;
      console.log("Updated totalViews:", totalConsultViews);
      this.lineConsultViewlineChartData.push(totalConsultViews);
      console.log("Updated lineChartData:", this.lineConsultViewlineChartData);
    });
  }
  private updateConsultPurchaseCountChartData() {
    this.lineConsultPurchaseCountlineChartData = [];
    let totalConsultViews = 0;
    this.consultPurchaseCount.forEach((element: any) => {
      totalConsultViews += element.numberOfViews;
      console.log("Updated totalViews:", totalConsultViews);
      this.lineConsultPurchaseCountlineChartData.push(totalConsultViews);
      console.log(
        "Updated lineChartData:",
        this.lineConsultPurchaseCountlineChartData
      );
    });
  }
  private updateDonationViewsChartData() {
    this.donationViewslineChartData = [];
    let totalConsultViews = 0;
    this.donationViews.forEach((element: any) => {
      totalConsultViews += element.fund;
      console.log("Updated totalViews:", totalConsultViews);
      this.donationViewslineChartData.push(totalConsultViews);
      console.log("Updated lineChartData:", this.donationViewslineChartData);
    });
  }

  initFlowViewLineChart() {
    console.log(this.lineFlowViewChartData);
    const lineChartCtx =
      this.flowViewslineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.flowviewslineChartLabels,
        datasets: [
          {
            data: this.lineFlowViewChartData,
            label: "Total FlowViews Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  private updateFlowViewChartData() {
    this.lineFlowViewChartData = [];
    let totalFlowViews = 0;
    this.flowViews.forEach((element: any) => {
      const flowViewsCount = parseInt(element.totalFlowViews, 10);
      if (!isNaN(flowViewsCount)) {
        totalFlowViews += flowViewsCount;
        this.lineFlowViewChartData.push(totalFlowViews);
      }
    });
  }

  initBundleViewLineChart() {
    console.log(this.lineBundleViewlineChartData);
    const lineChartCtx =
      this.bundleViewslineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.bundleViewslineChartLabels,
        datasets: [
          {
            data: this.lineBundleViewlineChartData,
            label: "Total BundleViews Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  private updateBundleViewChartData() {
    this.lineBundleViewlineChartData = [];
    let totalBundleViews = 0;
    this.bundleViews.forEach((element: any) => {
      const bundleViewsCount = parseInt(element.totalBundleViews, 10);
      if (!isNaN(bundleViewsCount)) {
        totalBundleViews += bundleViewsCount;
        this.lineBundleViewlineChartData.push(totalBundleViews);
      }
    });
  }

  extractBundleViewDateRange() {
    if (!this.bundleViews || this.bundleViews.length === 0) return;
    let totalBundleViews = 0;
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.bundleViews.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      const bundleViewsCount = parseInt(item.totalBundleViews, 10);
      if (!isNaN(bundleViewsCount)) {
        totalBundleViews += bundleViewsCount;
        groupedData.set(label, views + totalBundleViews);
      }
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data
    // Set data
    this.bundleViewslineChartLabels = sortedEntries.map(([label]) => label);
    this.lineBundleViewlineChartData = sortedEntries.map(([_, value]) => value);
  }

  extractConsultViewDateRange() {
    if (!this.consultViews || this.consultViews.length === 0) return;

    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.consultViews.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.purchasedAmount);
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data
    // Set data
    this.consultViewslineChartLabels = sortedEntries.map(([label]) => label);
    this.lineConsultViewlineChartData = sortedEntries.map(
      ([_, value]) => value
    );
  }

  extractConsultPurchaseCountDateRange() {
    if (!this.consultPurchaseCount || this.consultPurchaseCount.length === 0)
      return;

    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.consultPurchaseCount.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.numberOfViews);
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data

    // Set data
    this.consultPurchaseCountlineChartLabels = sortedEntries.map(
      ([label]) => label
    );
    this.lineConsultPurchaseCountlineChartData = sortedEntries.map(
      ([_, value]) => value
    );
  }

  extractDonationViewsDateRange() {
    if (!this.donationViews || this.donationViews.length === 0) return;

    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.donationViews.forEach((item) => {
      const date = new Date(item.receivedDate);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.fund);
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data
    // Set data
    this.donationViewslineChartLabels = sortedEntries.map(([label]) => label);
    this.donationViewslineChartData = sortedEntries.map(([_, value]) => value);
  }

  initFlowLinkClickLineChart() {
    console.log(this.flowLinkClicklineChartLabels);
    const lineChartCtx =
      this.flowLinkClicklineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.flowLinkClicklineChartLabels,
        datasets: [
          {
            data: this.flowlinkClicklineChartData,
            label: "Flow Link Click Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }

  private updateFlowLinkClickChartData() {
    let totalViews = 0;
    console.log(this.flowLinksClick);
    this.flowLinksClick.forEach((element) => {
      totalViews += element.totalCount;
      console.log("Updated totalViews:", totalViews);
      this.flowlinkClicklineChartData.push(totalViews);
      console.log("Updated lineChartData:", this.flowlinkClicklineChartData);
    });
  }
  extractFlowLinkClickDateRange() {
    if (!this.flowLinksClick || this.flowLinksClick.length === 0) return;
    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.flowLinksClick.forEach((item) => {
      const date = new Date(item.linkClickModels[0].createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.totalCount);
    });

    // Set data
    this.flowLinkClicklineChartLabels = Array.from(groupedData.keys());
    this.flowlinkClicklineChartData = Array.from(groupedData.values());
  }

  initBundleLinkClickLineChart() {
    console.log(this.bundlelinkClicklineChartData);
    const lineChartCtx =
      this.bundleLinkClicklineChartCanvas.nativeElement.getContext("2d");
    const lineChart = new Chart(lineChartCtx, {
      type: "line",
      data: {
        labels: this.bundleLinkClicklineChartLabels,
        datasets: [
          {
            data: this.bundlelinkClicklineChartData,
            label: "Bundle Link Click Over Time",
            borderColor: "orange",
            fill: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { labels: { color: this.chartLabelColor } },
        },
        scales: {
          y: {
            ticks: { stepSize: 1 },
          },
        },
      },
    });
  }
  private updateBundleLinkClickChartData() {
    let totalBundleViews = 0;
    console.log(this.bundleLinksClick);
    this.bundleLinksClick.forEach((element: any) => {
      totalBundleViews += element.totalCount;
      console.log("Updated totalViews:", totalBundleViews);
      this.bundlelinkClicklineChartData.push(totalBundleViews);
      console.log("Updated lineChartData:", this.bundlelinkClicklineChartData);
    });
  }
  extractBundleLinkClickDateRange() {
    if (!this.bundleLinksClick || this.bundleLinksClick.length === 0) return;

    const datePipe = new DatePipe("en-US");
    const groupedData = new Map<string, number>();
    const today = new Date();

    this.bundleLinksClick.forEach((item) => {
      const date = new Date(item.createdDateTime);
      let label = "";

      switch (this.selectedTimePeriod) {
        case "daily": {
          const isSameDay = date.toDateString() === today.toDateString();
          if (!isSameDay) return;
          label = datePipe.transform(date, "dd/MM/yyyy")!;
          break;
        }

        case "weekly": {
          // Calculate week number for current and previous 6 weeks
          const labels: string[] = [];
          for (let i = 0; i < 7; i++) {
            const weekDate = new Date(today);
            weekDate.setDate(today.getDate() - i * 7);
            const startOfYear = new Date(weekDate.getFullYear(), 0, 1);
            const weekNo = Math.ceil(
              ((+weekDate - +startOfYear) / 86400000 +
                startOfYear.getDay() +
                1) /
                7
            );
            labels.push(`Week ${weekNo}, ${weekDate.getFullYear()}`);
          }

          const startOfYear = new Date(date.getFullYear(), 0, 1);
          const weekNo = Math.ceil(
            ((+date - +startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7
          );
          label = `Week ${weekNo}, ${date.getFullYear()}`;
          if (!labels.includes(label)) return;

          break;
        }

        case "monthly": {
          const currentYear = today.getFullYear();
          if (date.getFullYear() !== currentYear) return;

          const monthDiff = today.getMonth() - date.getMonth();
          if (monthDiff < 0 || monthDiff > 11) return;

          label = datePipe.transform(date, "MMMM yyyy")!;
          break;
        }

        case "year": {
          const currentYearVal = today.getFullYear();
          if (date.getFullYear() < currentYearVal - 9) return;
          label = datePipe.transform(date, "yyyy")!;
          break;
        }
      }

      const views = groupedData.get(label) || 0;
      groupedData.set(label, views + item.totalCount);
    });
    const parseLabelToDate = (label: string): Date => {
      switch (this.selectedTimePeriod) {
        case "daily":
          return new Date(label.split("/").reverse().join("-")); // Convert dd/MM/yyyy to yyyy-MM-dd
        case "weekly": {
          const match = label.match(/Week (\d+), (\d+)/);
          if (!match) return new Date();
          const weekNo = +match[1];
          const year = +match[2];
          const jan1 = new Date(year, 0, 1);
          return new Date(jan1.setDate((weekNo - 1) * 7));
        }
        case "monthly":
          return new Date(label);
        case "year":
          return new Date(+label, 0, 1);
        default:
          return new Date();
      }
    };
    const sortedEntries = Array.from(groupedData.entries()).sort((a, b) => {
      return (
        parseLabelToDate(a[0]).getTime() - parseLabelToDate(b[0]).getTime()
      );
    });

    // Set data
    // Set data
    this.bundleLinkClicklineChartLabels = sortedEntries.map(([label]) => label);
    this.bundlelinkClicklineChartData = sortedEntries.map(
      ([_, value]) => value
    );
  }

  private get chartLabelColor(): string {
    return document.body.classList.contains('theme-dark') ? '#ffffff' : '#333333';
  }

  setNewandReturningUsers() {
    const uniqueEmails = new Set<string>();

    this.pageViews.forEach((element) => {
      // Check if the email is already in the set
      if (element.userEmail != "" && uniqueEmails.has(element.userEmail)) {
        // User is a returning user
        this.returningUsersCount++;
      } else {
        // User is a new user
        // Add the email to the set
        uniqueEmails.add(element.userEmail);
        this.newUsersCount++;
      }
    });

    const ctx = this.pieChartCanvas.nativeElement.getContext("2d");
    var arr = ["New Visitor", "Returning Visitor"];
    const pieChart = new Chart(ctx, {
      type: "pie",
      data: {
        labels: arr,
        datasets: [
          {
            data: [this.newUsersCount, this.returningUsersCount],
            backgroundColor: ["green", "blue"],
          },
        ],
      },
    });
  }
  
  toggleViewMode(): void {
    this.viewMode = this.viewMode === 'table' ? 'card' : 'table';
  }
  
  toggleBundleViewMode(): void {
    this.bundleViewMode = this.bundleViewMode === 'table' ? 'card' : 'table';
  }
}
